@app.controller 'JouleSelectorController', ($state, $element, LocationService, ShopifyService, ModalService, $scope, csConfig, MetadataService) ->
  @theme = 'light'
  @shopifyEndpoint = "#{csConfig.shopifyEndpoint}"
  @product = ShopifyService.getProductBySku 'cs10001'
  @premium = ShopifyService.getProductBySku 'cs10002'
  @clamp = ShopifyService.getProductBySku 'cs30001'
  @premiumVariant = @premium.variants[0]
  @clampVariant = @clamp.variants[0]

  # Convert Prices to Ingegers
  $scope.moneyFormat = (variant) ->
    price = parseInt(variant.price)
    money = '$' + price
    return money

  # Pre-select first variant in stock
  @availableVariants = (variants) ->
    _.filter(variants, (variant) -> !variant.inventory_management || (variant.inventory_management && variant.inventory_quantity > 0))

  @variantsInStock = @availableVariants(@product.variants)
  $scope.variantSelected = @variantsInStock[0]

  # Find selected variant ID and populate initial button URL
  @variantSelectedId = $scope.variantSelected.id
  @buttonUrl = "#{csConfig.shopifyEndpoint}/cart/add?id%5B%5D=#{@variantSelectedId}"

  # Update Prices
  @updatePrices = =>
    @variantSelectedSku = $scope.variantSelected.sku
    @joulePrice = parseInt($scope.variantSelected.price)

    # Calculate the slash price for each product
    if $scope.variantSelected.compare_at_price
      @jouleSlashPrice = parseInt($scope.variantSelected.compare_at_price)
    else
      @jouleSlashPrice = parseInt($scope.variantSelected.price)

    if @premiumVariant.compare_at_price
      @premiumSlashPrice = parseInt(@premiumVariant.compare_at_price)
    else
      @premiumSlashPrice = parseInt(@premiumVariant.price)

    if @clampVariant.compare_at_price
      @clampSlashPrice = parseInt(@clampVariant.compare_at_price)
    else
      @clampSlashPrice = parseInt(@clampVariant.price)

    # Bundles prices with Joule (make these variables)
    @premiumPrice = 20
    @clampPrice = 19

    # Calculate Discount percentage
    @premiumDiscount = Math.floor((1 - (@premiumPrice / @premiumSlashPrice)) * 100)
    @clampDiscount = Math.floor((1 - (@clampPrice / @clampSlashPrice)) * 100)

    # Change Total Price
    if $scope.premiumSelected && $scope.clampSelected
      @totalPrice = @joulePrice + @premiumPrice + @clampPrice
      @totalSlashPrice = @jouleSlashPrice + @premiumSlashPrice + @clampSlashPrice

    if !$scope.premiumSelected && $scope.clampSelected
      @totalPrice = @joulePrice + @clampPrice
      @totalSlashPrice = @jouleSlashPrice + @clampSlashPrice

    if $scope.premiumSelected && !$scope.clampSelected
      @totalPrice = @joulePrice + @premiumPrice
      @totalSlashPrice = @jouleSlashPrice + @premiumSlashPrice

    else if !$scope.premiumSelected && !$scope.clampSelected
      @totalPrice = @joulePrice
      if @joulePrice < @jouleSlashPrice
        @totalSlashPrice = @jouleSlashPrice
      else
        @totalSlashPrice = null

  # Update button URL
  @updateButton = =>
    # Update selected variant variable
    @variantSelectedId = $scope.variantSelected.id

    # Adding premium and clamp
    if $scope.premiumSelected && $scope.clampSelected
      @buttonUrl = "#{csConfig.shopifyEndpoint}/cart/add?id%5B%5D=#{@variantSelectedId}&id%5B%5D=#{@premiumVariant.id}&id%5B%5D=#{@clampVariant.id}"

    # Adding just Premium
    if $scope.premiumSelected && !$scope.clampSelected
      @buttonUrl = "#{csConfig.shopifyEndpoint}/cart/add?id%5B%5D=#{@variantSelectedId}&id%5B%5D=#{@premiumVariant.id}"

    # Adding just clamp
    if !$scope.premiumSelected && $scope.clampSelected
      @buttonUrl = "#{csConfig.shopifyEndpoint}/cart/add?id%5B%5D=#{@variantSelectedId}&id%5B%5D=#{@clampVariant.id}"

    # No Add ons
    else if !$scope.premiumSelected && !$scope.clampSelected
      @buttonUrl = "#{csConfig.shopifyEndpoint}/cart/add?id%5B%5D=#{@variantSelectedId}"

  $scope.updateSelection = =>
    @updateButton()
    @updatePrices()

  @checkStock = (productVariant) ->
    if productVariant.inventory_management && productVariant.inventory_quantity > 0
      return true
    else if productVariant.inventory_management && productVariant.inventory_quantity < 0
      return false
    else
      return true

  @openInternationalJoule = ->
    ModalService.open('internationalJoule', {type: 'normal', sku: @sku, user: @currentUser, checkoutUrl: @url, outOfStock: @product.inventory_quantity <= 0})

  @forceInUS = ->
    LocationService.forceInUS()

  # Set Location
  @isInUS = ->
    LocationService.isInUS()

  # Initialization
  $scope.updateSelection()

  # SEO Metadata
  canonical = '/joule'
  title = 'Joule: Sous Vide by ChefSteps'
  description = 'Joule is the sous vide tool that changes everything. Controlled by a groundbreaking custom app, Joule is a sleek, powerful cooking tool that makes sous vide a real part of today’s kitchen.'
  image = 'https://d3awvtnmmsvyot.cloudfront.net/api/file/eP71dY8XQhx1vuvVFNxt'
  MetadataService.set
    title: title
    description: description
    keywords: "joule, sous vide, chefsteps, circulator"
    canonical: canonical
    image: image
    sousVideTargeted: true
    og:
      url: canonical


  this
